import {connect} from "react-redux";
import PropTypes from "prop-types";

import {setLeadCaptureClickCount} from "../../../actions/userFunctions";
import {LOOK_OVERLAYS} from "../core/constants";
import {setLookOverlayOpened} from "../../../actions/lookFunctions";


const WithClickCount = (props) => {

  const {fabricatorSettings, isPhoneNumberValidated, leadCaptureClickCount, setLeadCaptureClickCount, children,
    setLookOverlayOpened} = props;

  const maxClickCountReached = () => {
    if (!isPhoneNumberValidated && fabricatorSettings.clickLeadCapture) {
      const newLeadCount = leadCaptureClickCount + 1;
      if (newLeadCount >= fabricatorSettings.clickLeadCount) {
        setLookOverlayOpened(LOOK_OVERLAYS.leadCapture);
        return true;
      } else {
        setLeadCaptureClickCount(newLeadCount);
      }
    }
    return false
  }


  return children(maxClickCountReached)
};

WithClickCount.propTypes = {
  children: PropTypes.any.isRequired
}

const mapStateToProps = (store) => {
  const {settings} = store.fabricatorState;
  const {isPhoneNumberValidated, leadCaptureClickCount} = store.userState;
  return {
    fabricatorSettings: settings,
    isPhoneNumberValidated,
    leadCaptureClickCount,
  }
};

const mapDispatchToProps = {
  setLeadCaptureClickCount,
  setLookOverlayOpened,
};

export default connect(mapStateToProps, mapDispatchToProps)(WithClickCount)
